import { render } from "./appointment.vue?vue&type=template&id=de1c2b62&scoped=true&ts=true"
import script from "./appointment.vue?vue&type=script&lang=ts"
export * from "./appointment.vue?vue&type=script&lang=ts"

import "./appointment.vue?vue&type=style&index=0&id=de1c2b62&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1c2b62"]])

export default __exports__